// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_urp","cls2":"UpsellModalRedesign-cls2_7Yh UpsellModalRedesign-cls1_urp"};